import React, { memo } from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import identity from 'lodash/identity';

const TableForListSubItem = ({ pairs, getLabelForValue = identity, className = '' }) => {
  return (
    <Table size="small" className={`list-subitem ${className}`}>
      <TableBody>
        {pairs.map((pair, idx) => (
          <TableRow
            key={idx}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            className={'table-row'}
          >
            <TableCell component="th" scope="row">
              {pair[ 0 ]}
            </TableCell>
            <TableCell>{getLabelForValue(pair[ 1 ])}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default memo(TableForListSubItem);
